import styled from "@emotion/styled";
import { LightMode, Variables } from "@repo/skapa";

export const HeaderContainer = styled.div`
  background-color: ${LightMode.colourStaticWhite};
  padding: ${Variables.space75} ${Variables.space75};

  @media (min-width: ${Variables.breakpointM}) {
    padding: ${Variables.space75} ${Variables.space125};
  }
`;
